<template>
  <p :style="style">
    <strong v-if="customText">{{ customText }}</strong>
    <strong v-else>
      {{ type?.name || '-' }}
    </strong>
  </p>
</template>

<script>
import { bovineColors as colors } from '../lib/bovines';

export default {
  name: 'BovineType',
  props: {
    type: Object,
    small: Boolean,
    inactive: Boolean,
    customText: String,
  },
  computed: {
    style() {
      return {
        fontSize: this.small && '0.85rem',
        width: 'fit-content',
        heigth: '10px',
        color: 'white',
        textAlign: 'center',
        borderRadius: '3px',
        padding: '0px 8px',
        ...(this.inactive ? { filter: 'grayscale(100%)' } : {}),
        ...(colors[this.type?.id] || {}),
      };
    },
  },
};
</script>

<style>
</style>